import { useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { useToast } from "../context/ToastContext";
import { listenForUserEvents } from "../api/socket";

const STATUS_TOAST = {
  accepted: "A dispatcher has accepted your order.",
  arrived_at_pickup: "Your dispatcher has arrived at pickup.",
  picked_up: "Your package has been picked up.",
  in_transit: "Your delivery is on its way.",
  delivered: "Your package has been delivered.",
  completed: "Delivery complete. Thank you!",
  cancelled: "Your order has been cancelled.",
  failed: "Your delivery could not be completed."
};

// App-wide listener for the signed-in customer: toasts every status change
// on any of their orders, whatever page they're on. The Track page for that
// same order shows its own banner, so it's skipped there to avoid doubling up.
export default function LiveOrderUpdates() {
  const { account } = useAuth();
  const { toastInfo, toastError } = useToast();
  const userId = account?.role === "user" ? account._id : null;

  useEffect(() => {
    if (!userId) return;
    let lastKey = "";
    return listenForUserEvents(userId, {
      onOrderUpdate: ({ orderId, status, by }) => {
        // Customer's own actions (cancel, payment switch) already show feedback.
        if (by === "user") return;
        if (window.location.pathname === `/track/${orderId}`) return;
        const key = `${orderId}:${status}`;
        if (key === lastKey) return; // payment/stop updates re-send the same status
        lastKey = key;
        const text = STATUS_TOAST[status];
        if (!text) return;
        const ref = `#${String(orderId).slice(-6).toUpperCase()}`;
        (["cancelled", "failed"].includes(status) ? toastError : toastInfo)(`Order ${ref}: ${text}`);
      }
    });
  }, [userId, toastInfo, toastError]);

  return null;
}
